import { render, staticRenderFns } from "./BrandTile.vue?vue&type=template&id=4c491856&"
import script from "./BrandTile.vue?vue&type=script&lang=js&"
export * from "./BrandTile.vue?vue&type=script&lang=js&"
import style0 from "./BrandTile.vue?vue&type=style&index=0&id=4c491856&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports